import { GENERAL_SUBMIT_SUCCESS } from 'src/common/constants/localizations/settings';
import ActionSuccessAlert from '../../shared/alerts/ActionSuccessAlert';

const GeneralSettingsSuccess = () => (
  <div data-testid="generalSettingsSuccess">
    <ActionSuccessAlert key="generalSettingsSuccess" localizedText={GENERAL_SUBMIT_SUCCESS} />
  </div>
);

export default GeneralSettingsSuccess;
